import Vue from 'vue';
import Vuex from 'vuex';
import EditUserIndex from './components/user/profile';
import OrgManagementIndex from './components/organization/manage';
import OrgCalendarIndex from './components/organization/calendar';
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
// import '../../sass/main.scss';

Vue.use(Vuex);
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);

const store = new Vuex.Store({
  state: {
    organization: {},
  },
  //eslint-disable-next-line vue/sort-keys
  mutations: {
    setCurrentOrganization(state, {organization}){
      // eslint-disable-next-line vue/sort-keys
      console.log({ state, organization });
      state.organization = { ...organization };
    },
  },
  //eslint-disable-next-line vue/sort-keys
  actions:{
    setCurrentOrganization({ commit },{ organization }){
      commit('setCurrentOrganization',{ organization });
    },
  },
});

new Vue({
  el: '#vueApp',
  // template: '<App/>',
  // components: { App }
  store,
  components: {
    //Use name field as key to Handle browser not supporting camel case
    [OrgManagementIndex.name]: OrgManagementIndex,
    [OrgCalendarIndex.name]: OrgCalendarIndex,
    [EditUserIndex.name]: EditUserIndex,
  },
  data:{
    message:'Hello World',
  },
});
